// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"1f908705","209":"d6402d56","343":"f468c9ad","345":"7e89c560","380":"2ca31804","453":"fd14b9a2","506":"67dfe19d","643":"41222821","645":"e0b4731b","662":"aab3f728","665":"32dbd373","723":"69e3790d","789":"1d2aabc5","812":"5f08c4cb"}[chunkId] + ".chunk.js";
};